import { useNavigate } from 'react-router-dom'
import GDPRModal from '../components/GDPRModal'

const PrivacyPage = () => {
  const navigate = useNavigate()

  return (
    <GDPRModal
      open={true}
      onClose={() => navigate('/')}
      openedFrom="link"
    />
  )
}

export default PrivacyPage